import React from "react";
import {
    CopyrightLine,
    CopyrightText,
    CopyrightWrapper,
    LogoWrapper,
    VigoLogo,
    Wrapper
} from "./CustomerFooter.styles";

import FooterLogo from "../../../../../public/images/footer-logo.svg";
import moment from "moment";

export const CustomerFooter = () => {
    return (
        <Wrapper>
            {/* <LogoWrapper>
                <VigoLogo src={FooterLogo} alt="Vigo Footer Logo" />
            </LogoWrapper> */}
            <CopyrightWrapper>
                {/* <CopyrightText>{moment().year() || 2021} Tüm hakları saklıdır.</CopyrightText> */}
                {/* <CopyrightLine /> */}
            </CopyrightWrapper>
        </Wrapper>
    );
};
